import instance from './axios';

export const triggerFatigueHeal = () => {
    instance.post('/fatigue').catch(() => {});
};
